const initialState = {
    pending: false,
    warmHours: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};

const warmHoursReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_HOURS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_WARM_HOURS_SUCCESS':
            return {
                ...state,
                pending: false,
                warmHours: action.warmHours,
                // page: action.page,
                // pageCount: action.pageCount,
                // itemsCount: action.itemsCount
            };
        case 'GET_COLD_HOURS_SUCCESS':
            return {
                ...state,
                pending: false,
                coldHours: action.warmHours,
                // page: action.page,
                // pageCount: action.pageCount,
                // itemsCount: action.itemsCount
            };
        case 'GET_HOURS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_HOUR':
            return {
                ...state,
                selected: action.selected
            };
        case 'ADD_HOUR_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_HOUR_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
}

export default warmHoursReducer;
